// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2xh8T","imageUploader":"EGiftCard_imageUploader__3cFx5"};